<template>
  <div>
    <!-- 编辑 -->
    <template>
      <Modal v-model="visible" title="编辑用户" draggable class-name="vertical-center-modal" ok-text="保存" width="730" height="300"
        style="overflow: hidden;" @on-ok="ok" @on-cancel="cancel" :loading="loading">
        <Form ref="details" :model="details" :rules="ruleValidate" label-position="right" :label-width="120" style="width: 714px; height: 400px; margin: 0 auto; overflow-y: auto; padding-top: 20px;">

          <Row span="24">           
            <Col span="10">
              <FormItem label="员工编号" prop="EmployeeNumber">
                <Input v-model="details.EmployeeNumber" readonly placeholder="请输入员工编号"></Input>
              </FormItem>
            </Col>
            <Col span="10">
              <FormItem label="登录用户名" prop="LoginCode">
                <Input v-model="details.LoginCode" readonly placeholder="请输入登录用户名"></Input>
              </FormItem>
            </Col>
          </Row>

          <Row span="24">
            <Col span="10">
              <FormItem label="姓名" prop="Name">
                <Input v-model="details.Name" placeholder="请输入姓名"></Input>
              </FormItem>
            </Col>
            <Col span="10">
              <FormItem label="移动电话" prop="Phone">
                <Input v-model="details.Phone" placeholder="请输入移动电话"></Input>
              </FormItem>
            </Col>
          </Row>

        </Form>
      </Modal>
    </template>
  </div>
</template>

<script>
  export default {
    props: {
      isShow: {
        type: Boolean,
        default: false
      },
      details: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    data() {
      return {
        visible: false,
        formLeft: {},
        loading: true,

        ruleValidate: {
          EmployeeNumber: [{ required: true, message: '员工编号不能为空', trigger: 'blur' }],
          LoginCode: [{ required: true, message: '登录用户名不能为空', trigger: 'blur' }],
          LoginPassword: [{ required: true, message: '用户登录密码不能为空', trigger: 'blur' }],
          Name: [{ required: true, message: '姓名', trigger: 'blur' }]
        }
      }
    },
    watch: {
      isShow(newValue, old) {
        this.visible = newValue;
      }
    },
    mounted() {

    },
    methods: {

      ok(value) {
        let _this = this;
        _this.$refs.details.validate(valid => {
            if (valid) {
                _this.$emit("on-change", false, _this.details);
            } else {
                _this.$Message.error("请输入必填项");
                _this.loading = false;
                _this.$nextTick(() => {
                    _this.loading = true;
                });
            }
        });

      },
      cancel(value) {
        this.$emit("on-change", this.visible)
      }
    },
  }
</script>

<style scoped="scoped">

</style>
